import React, {useEffect} from "react";
import {Apis} from "../util/data";
import axios from "axios";
import {errorToast, successToast} from "./layout/ToastStyles";
import Input from "./forms/FormEl";
import FormGroup from "./forms/FormGroup";
import {useForm} from "react-hook-form";

const UpdatePonderacion =({setAction, setTitle,...props}) => {


  const upload = async (formData) => {
    try {
      const {data} = await axios.post(Apis.PROD + '/riesgo/ponderacion' , formData)
      if(data) successToast("Se ha guardado correctamente")
    }
    catch (error){
      errorToast("Error al guardar")
      console.log(error)
    }
  }

  const {register, handleSubmit, formState: {errors}} = useForm(
    {defaultValues: props}
  );

  useEffect(() => {
    setTitle("Valor de ponderacion")
    setAction(()=>handleSubmit(upload))
  }, [props.id])

  return (
    <form>
      <FormGroup>
        <label>Valor</label>
        <Input type='text' {...register("valor", {required: "Campo obligatorio"})}/>
        {errors.valor && <p style={{color: 'red'}}>{errors.valor?.message}</p>}
      </FormGroup>
    </form>
  );

}

export default UpdatePonderacion;